// The CSS "Y" speech-bubble badge + wordmark from the design
export default function YappyliLogo({ small = false }) {
  return (
    <>
      <div className="yappyli-badge" style={small ? { width: 32, height: 32 } : undefined}>
        <div
          className="yappyli-bubble"
          style={small ? { width: 20, height: 16, fontSize: '0.75rem' } : undefined}
        >
          Y
        </div>
      </div>
      <span>Yappyli</span>
    </>
  );
}
